import { ColorTokens, BorderRadiusTokens, ProgressIndicatorTypeTokens, SizeTypeTokens, } from '@voltmoney/schema';
export const progessIndicatorTypeTokensMap = {
    [ProgressIndicatorTypeTokens.default]: {
        color: ColorTokens.Blue_600,
        borderRadius: BorderRadiusTokens.BR4,
        height: SizeTypeTokens.MD,
    },
    [ProgressIndicatorTypeTokens.LINEAR]: {
        color: ColorTokens.Secondary_100,
        borderRadius: BorderRadiusTokens.BR4,
        height: SizeTypeTokens.MD,
    },
};
